import { createFileRoute, notFound, Outlet } from '@tanstack/react-router';
import { getContractDetailsQuery } from '@/app/hooks/queries/useContracts';
import { Main } from '@/app/ui/components/main';
import { ChatType, EvaluationTypeLabelsEnum } from '@/app/utils/constants';
import AIChatProvider from '@/app/components/features/aiChat/AIChatContext';
import useEntryChat from '@/app/components/features/aiChat/hooks/useEntryChat';
import { Sidechat } from '@/app/components/shared/Sidechat';
import { Spinner } from '@/app/ui/components/spinner';
import { useSuspenseQuery } from '@tanstack/react-query';
import { VersionHistoryPanel } from '@/app/components/features/evaluations/VersionHistoryPanel/VersionHistoryPanel';

export const Route = createFileRoute(
  '/_authed/project/$projectId/_layout/(evaluation)/contracts/$contractId/_layout',
)({
  component: RouteComponent,
  loader: async (opts) => {
    const evaluation = await opts.context.queryClient.ensureQueryData(
      getContractDetailsQuery(opts.params.contractId),
    );
    if (!evaluation) throw notFound();
  },
  pendingComponent: () => (
    <Main className="relative">
      <Spinner kind="inset" />
    </Main>
  ),
});

function RouteComponent() {
  const { contractId } = Route.useParams();
  const { data: evaluation } = useSuspenseQuery(getContractDetailsQuery(contractId));

  const stream = useEntryChat({
    id: contractId,
    namespace: ChatType.CONTRACT,
  });

  return (
    <AIChatProvider
      chatType={ChatType.CONTRACT}
      sourceStream={stream}
      chatInitialOpen={false}
      evaluationName={evaluation.name}
      evaluationType={EvaluationTypeLabelsEnum.CONTRACT}
      evaluationId={contractId}
    >
      <Main>
        <Outlet />
      </Main>
      <VersionHistoryPanel evalId={contractId} />
      <Sidechat />
    </AIChatProvider>
  );
}
